import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Music"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 3H7.5C6.67192 3.00083 6.00083 3.67192 6 4.5V15.417C5.54605 15.1469 5.02821 15.003 4.5 15C2.84315 15 1.5 16.3431 1.5 18C1.5 19.6569 2.84315 21 4.5 21C6.15685 21 7.5 19.6569 7.5 18V9H18.75V15.417C18.2961 15.1469 17.7782 15.0029 17.25 15C15.5931 15 14.25 16.3431 14.25 18C14.25 19.6569 15.5931 21 17.25 21C18.9069 21 20.25 19.6569 20.25 18V4.5C20.2492 3.67192 19.5781 3.00083 18.75 3ZM4.5 19.5C3.67157 19.5 3 18.8284 3 18C3 17.1716 3.67157 16.5 4.5 16.5C5.32843 16.5 6 17.1716 6 18C5.99917 18.8281 5.32808 19.4992 4.5 19.5ZM17.25 19.5C16.4216 19.5 15.75 18.8284 15.75 18C15.75 17.1716 16.4216 16.5 17.25 16.5C18.0784 16.5 18.75 17.1716 18.75 18C18.7488 18.8279 18.0779 19.4988 17.25 19.5ZM7.5 4.5H18.75V7.5H7.5V4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Music.vue"]]);
